import React from "react";
import { Button } from "@headlessui/react";
import IndexFunctionCard from "./IndexFunctionCard";
import IndexHeader from "./IndexHeader";
import { FunctionOptions } from "./../../types/FunctionOptions";

export interface IndexFunctionsProps {}

const IndexFunctions: React.FC<IndexFunctionsProps> = (props: IndexFunctionsProps) => {

	const conceptOptions: FunctionOptions = {
		selfService: "Combined Platforms provides you with the planning detail required to proceed to design. You run your own process to provide these.",
		collaborative: "Combined Platforms provides you with a consultant to work through the concept, ideation and planning process.",
		turnkey: "Combined Platforms works independently of your organisation on the process (based off an initial conversation), and provides you with documented options.",
	};

	const designOptions: FunctionOptions = {
		selfService: "You run your own process to provide design prototypes in an acceptable format (Figma, Adobe XD, Uizard or any SVG compliant design tool).",
		collaborative: "Combined Platforms connects you with a designer to work through the design process.",
		turnkey: "Combined Platforms works independently of your organisation on the process, and provides you with one or more design options.",
	};

	const developmentOptions: FunctionOptions = {
		selfService: "You use your own team and methodologies to develop the platform.",
		collaborative: "Combined Platforms works with your team to co-develop the platform using the Combined Platforms processes, tools and software stack.",
		turnkey: "Combined Platforms works independently of your organisation on the development (based off an agreed concept and design), and provides you with an fully operational platform.",
	};

	const releaseOptions: FunctionOptions = {
		selfService: "Combined Platforms provides you with the operational platform. You deploy into your own infrastructure and maintain with your own team.",
		collaborative: "Combined Platforms provides you with a consultant to transition the completed platform to your infrastructure and team.",
		turnkey: "Combined Platforms maintains and operates the site in our infrastructure, including all support and maintainance.",
	};

	return (
		<>
			<IndexHeader title="Development Services">
				Combined Platforms provides services at each stage of the Software Development Lifecycle.
				<br />
				<br />
				Whether you are a startup or an established organisations, Combined Platforms can provide services ranging from simple project co-ordination to full turnkey development including ongoing operations. The offerings are fully flexible. You can mix and match options according to what makes sense for your organisation.
				<br />
				<br />
				The options are outlined below:
			</IndexHeader>

			<div id="indexfunctions-cards">
				<IndexFunctionCard index={0} image="indexfunctions_000009.png" title="Concept, Ideation and Planning" options={conceptOptions} description="The foundation of efficiently delivered software is established in the early stages. This phase ensures alignment of business needs with technical solutions, where ideas are refined, validated, and organized into actionable plans for maximum impact." />
				<IndexFunctionCard index={1} image="indexfunctions_000016.png" title="Design" options={designOptions} description="Efficient solutions start with purposeful design. By crafting intuitive and scalable system architectures and user experiences, this stage transforms abstract concepts into clickable design prototypes, ready for implementation." />
				<IndexFunctionCard index={2} image="indexfunctions_000134.png" title="Development and Testing" options={developmentOptions} description="Efficiency thrives on seamless execution. In this phase, cutting-edge AI tools drive rapid development cycles, and rigorous testing ensures robustness and reliability, creating software that delivers immediate value." />
				<IndexFunctionCard index={3} last={true} image="indexfunctions_000215.png" title="Release and Operations" options={releaseOptions} description="Smooth releases and stable operations define efficient delivery. Leveraging automation and AI-powered monitoring, this stage ensures continuous deployment and proactive management for optimal system performance." />
			</div>

			<br />
			<br />
		</>
	);

};

export default IndexFunctions;